import React from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import MyPagination from "../../Components/MyPagination";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import DatePickers from "../../Components/DatePickers";
import Layout from "../../Layout";
import PosiTabs from "../../Components/PosiTabs";

import { withRouter } from "react-router";
import { fromMonthly, toMonthly } from "fuction/date";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import useFilter from "Hooks/useFilter";
import { animateScroll as scroll } from 'react-scroll';
import googleAnalytics from "fuction/googleAnalytics";
import Toolbar from '@material-ui/core/Toolbar';
import {useQueryString} from "Hooks/useQueryString";

const useStyles = makeStyles((theme) => ({
  rank: {
    textAlign: "center",
    width: "120px",
    fontSize: "20px",
  },
  word: {
    whiteSpace: "pre-wrap",
    cursor: "pointer",
    fontSize: "20px",
  },
  count: {
    paddingRight: "25px!important",
    color: "#FF0000",
    whiteSpace: "nowrap",
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
  },
  sticky: {
    position: "-webkit-sticky", /* safari対応 */
    position: "sticky",
    top: 64,
    zIndex: 1,
    backgroundColor: "white",
    paddingLeft: 90,
    paddingRight: 90,
    width: "100%"
  },
}));

function Keywords(props) {
  const { request, convertQueryParam } = useApi();
  const auth = useAuth();
  const filter = useFilter();
  const classes = useStyles();
  const queryParams = useQueryString();

  const fromDate = fromMonthly(filter.state.filteredDateFrom);
  const toDate = toMonthly(filter.state.filteredDateTo);
  const activeGroup = auth.state.activeGroup;

  const [keywords, setKeywords] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [totalCount, setTotalCount] = React.useState(0);

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  const handleTableRow = (word) => {
    props.history.push(`/keywords/monthly?activeGroup=${activeGroup}&word=${word}`);
  };

  const usersParams = {
    range: [fromDate, toDate],
    filter: {
      pn: filter.state.posiNegaTab,
    },
    order: "asc",
    pagination: {
      page: page,
      limit: "50",
    },
  };

  // キーワード情報を取得
  const rquestKeywords = () => {
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで画面表示されてしまう。
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得しても画面に反映されない（set○○(●●)までで再々レンダは走らない）ので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeGroup = queryParams.get("activeGroup");
    if (activeGroup && auth.state.activeGroup !== parseInt(activeGroup, 10)) {
      return;
    }
    request({
      method: "GET",
      url: `data/:account_id/keywords/${
        auth.state.activeGroup
      }/ranking?${convertQueryParam(usersParams)}`,
    }).then((data) => {
      setKeywords(data.data);
      setTotalCount(data.meta.total_count);
      scrollToTop()
    });
  }

  // 初回レンダリングフラグ
  const isFirstRender = React.useRef(false);
  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - キーワード分析";
    isFirstRender.current = true;
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  React.useEffect(() => {
    // 初回レンダー判定
    if(isFirstRender.current) { 
      // 初回レンダーではないように
      isFirstRender.current = false;
    } else {
      rquestKeywords();
    }
  }, [page]);

  React.useEffect(() => {
    if (auth.state.activeGroup === 0) {
      return;
    }
    if (page === 1) {
      rquestKeywords();
    } else {
      setPage(1);
    }
  }, [auth.state.activeGroup, filter.state]);

  const StyledTableCell = withStyles(() => ({
    root: {
      padding: "6px",
    },
  }))(TableCell);
  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
      cursor: "pointer",
    },
  }))(TableRow);
  return (
    <Layout
      content={
        <Grid container spacing={3}>
          <Toolbar className={classes.sticky}>
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                alignItems="flex-end"
                justifyContent="flex-start"
              >
                <DatePickers />
                <div className={classes.divider}></div>
                <PosiTabs />
              </Grid>
              <Grid container spacing={3} className={classes.formControl} justifyContent="center">
                <MyPagination
                count={Math.ceil(totalCount / 50)}
                currentPage={page}
                handlePagination={(page) => setPage(page)}
                />
              </Grid>
            </Grid>
          </Toolbar>

          {/* Recent Orders */}
          <Grid item xs={12}>
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="customized table">
                <TableBody>
                  {keywords.map((row, index) => (
                    <StyledTableRow
                      key={index}
                      onClick={() => handleTableRow(row.word)}
                    >
                      <StyledTableCell component="th" scope="row" className={classes.rank}>
                        {row.rank}
                      </StyledTableCell>
                      <StyledTableCell align="left" className={classes.word} >
                        <p>{row.word}</p>
                      </StyledTableCell>
                      <StyledTableCell align="right" className={classes.count}>
                        {row.count}件
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      }
    />
  );
}

export default withRouter(Keywords);
